export const RANK_TRACKER_KEYWORD_DETAILS_DATA_ATTRIBUTE_IDS = {
  Radio: {
    Organic: 'RankTracker.KeywordDetails.KeywordRankingPerformance.Organic',
    Sponsored: 'RankTracker.KeywordDetails.KeywordRankingPerformance.Sponsored'
  },
  KeywordSelection: {
    MatchTable: 'RankTracker.KeywordDetails.KeywordSelection.MatchTable',
    Buttons: {
      Apply: 'RankTracker.KeywordDetails.KeywordSelection.Buttons.Apply'
    },
    Dropdown: 'RankTracker.KeywordDetails.KeywordSelection.Dropdown'
  },
  KeywordDatesSelection: {
    Dropdown: 'RankTracker.KeywordDetails.KeywordDatesSelection.Dropdown',
    ApplyButton: 'RankTracker.KeywordDetails.KeywordDatesSelection.ApplyButton',
    CancelButton:
      'RankTracker.KeywordDetails.KeywordDatesSelection.CancelButton'
  },
  KeywordTable: {
    SortByKeyword: 'RankTracker.KeywordDetails.KeywordTable.SortByKeyword',
    SortBySearchVolume:
      'RankTracker.KeywordDetails.KeywordTable.SortBySearchVolume',
    SortByOrganicRank:
      'RankTracker.KeywordDetails.KeywordTable.SortByOrganicRank',
    SortBySponsoredRank:
      'RankTracker.KeywordDetails.KeywordTable.SortBySponsoredRank',
    SortByInListing: 'RankTracker.KeywordDetails.KeywordTable.SortByInListing',
    SortByEaseToRank:
      'RankTracker.KeywordDetails.KeywordTable.SortByEaseToRank',
    SortByPPCBid: 'RankTracker.KeywordDetails.KeywordTable.SortByPPCBid',
    SortByLastChecked:
      'RankTracker.KeywordDetails.KeywordTable.SortByLastChecked',
    FiltersDropdown: 'RankTracker.KeywordDetails.KeywordTable.FiltersDropdown',
    SearchByKeyword: 'RankTracker.KeywordDetails.KeywordTable.SearchByKeyword'
  },

  Annotations: {
    View: 'RankTracker.KeywordDetails.Annotations.View',
    Add: 'RankTracker.KeywordDetails.Annotations.Add',
    Delete: {
      Cancel: 'RankTracker.KeywordDetails.Annotations.Delete.Cancel',
      OpenConfirmationModal:
        'RankTracker.KeywordDetails.Annotations.Delete.OpenConfirmationModal',
      DeleteConfirmation:
        'RankTracker.KeywordDetails.Annotations.Delete.DeleteConfirmation'
    },
    Edit: {
      OpenEditForm: 'RankTracker.KeywordDetails.Annotations.Edit.OpenEditForm',
      Cancel: 'RankTracker.KeywordDetails.Annotations.Edit.Cancel',
      Confirm: 'RankTracker.KeywordDetails.Annotations.Edit.Confirm'
    }
  }
}
